<template lang="pug">
div
  v-progress-linear(v-if='loading' indeterminate color='#18bedf')
  v-alert(v-else-if='loadError' type='error' dense text) {{ loadError }}
  template(v-else)
    v-checkbox.mt-0(v-model='form.enabled' :label=`$t('TENANT_PIPELINE.ENABLE_WORK_AGENT')` :disabled='busy' color='#18bedf' hide-details @change='emitStatus')
    v-alert.mt-2(v-if='initial.enabled && !form.enabled' type='warning' dense text) {{$t('TENANT_PIPELINE.WORK_AGENT_DISABLE_HINT')}}
    div.mt-4(v-show='form.enabled')
      v-text-field(
        v-model='form.maxThread'
        :label=`$t('TENANT_PIPELINE.MAX_THREAD')`
        type='number'
        :min='1'
        outlined
        dense
        :rules='[maxThreadRule]'
        :disabled='busy'
        @input='emitStatus'
      )
      model-list-editor(:key='editorKey' :source='state.models' :busy='busy' @input='onModelsInput' @valid='onModelsValid')
</template>

<script>
import Vue from "vue";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";
import modelListEditor from "@/components/TenantCenter/Pipeline/pipelineModelListEditor";
import { errorText, snapshot } from "@/components/TenantCenter/Pipeline/pipelineUtils";

const DEFAULT_MAX_THREAD = 100;

export default Vue.extend({
  props: {
    tenant: { type: Object, require: true },
    busy: { type: Boolean, default: false },
  },
  components: {
    modelListEditor,
  },
  data() {
    return {
      loading: true,
      loadError: '',
      state: null,
      initial: { enabled: false, maxThread: DEFAULT_MAX_THREAD },
      form: { enabled: false, maxThread: DEFAULT_MAX_THREAD },
      models: null,
      modelsBaseline: null,
      modelsValid: false,
      editorKey: 0,
      maxThreadRule: (v) => /^[1-9]\d*$/.test(String(v)) || i18n.t('RULE.RULE_ALPHA_NUMERIC'),
    };
  },
  async created() {
    try {
      const response = await TenantCenterService.pipelineGetStage(this.tenant.schema_name, 'workagent');
      this.applyState(response.data);
    } catch (error) {
      this.loadError = errorText(error);
    } finally {
      this.loading = false;
      this.emitStatus();
    }
  },
  methods: {
    applyState(state) {
      this.state = state;
      const maxThread = state.max_thread === null || state.max_thread === undefined ? DEFAULT_MAX_THREAD : state.max_thread;
      this.initial = { enabled: state.enabled, maxThread: maxThread };
      this.form = { enabled: state.enabled, maxThread: maxThread };
      // 重建編輯元件，讓它第一次送出的內容成為新的比較基準
      this.modelsBaseline = null;
      this.editorKey += 1;
    },
    onModelsInput(val) {
      this.models = val;
      if (this.modelsBaseline === null) {
        this.modelsBaseline = snapshot(val);
      }
      this.emitStatus();
    },
    onModelsValid(val) {
      this.modelsValid = val;
      this.emitStatus();
    },
    isDirty() {
      if (this.form.enabled !== this.initial.enabled) {
        return true;
      }
      if (!this.form.enabled) {
        return false;
      }
      return String(this.form.maxThread) !== String(this.initial.maxThread) || snapshot(this.models) !== this.modelsBaseline;
    },
    emitStatus() {
      this.$nextTick(() => {
        if (this.loading || this.loadError) {
          this.$emit('status', { dirty: false, ready: !this.loading });
          return;
        }
        const dirty = this.isDirty();
        const ready = !dirty || !this.form.enabled || (this.maxThreadRule(this.form.maxThread) === true && this.modelsValid);
        this.$emit('status', { dirty: dirty, ready: ready });
      });
    },
    async submit() {
      this.$emit('progress', i18n.t('TENANT_PIPELINE.UPDATING'));
      try {
        const response = await TenantCenterService.pipelineUpdateStage(this.tenant.schema_name, 'workagent', {
          enabled: this.form.enabled,
          max_thread: Number(this.form.maxThread),
          models: this.models,
        });
        this.applyState(response.data);
      } catch (error) {
        throw new Error(errorText(error));
      } finally {
        this.emitStatus();
      }
    },
  },
});
</script>
